import type { PageMeta } from '../lib/seo';

export const COMPARISONS: Record<string, { meta: PageMeta; heading: string; intro: string; audience: string }> = {
  runway: {
    meta: { title: 'Runway Alternative for Filmmakers | Induce vs Runway Gen-4', description: 'Compare Induce and Runway for script-driven film production, shot planning, and continuity.', path: '/vs/runway' },
    heading: 'Induce vs Runway: Which AI Video Tool Fits Your Production?',
    intro: 'Compare a script-to-cut filmmaking workflow with a clip-focused creative workflow.',
    audience: 'filmmakers',
  },
  higgsfield: {
    meta: { title: 'Higgsfield Alternative for Filmmakers | Induce vs Higgsfield', description: 'Compare Induce and Higgsfield for AI filmmaking and content creation.', path: '/vs/higgsfield' },
    heading: 'Induce vs Higgsfield: AI Filmmaking Platform vs AI Content Tools',
    intro: 'Explore which workflow fits your project, from individual creative assets to a continuous film.',
    audience: 'filmmakers',
  },
  synthesia: {
    meta: { title: 'Synthesia Alternative for Agencies | Induce vs Synthesia Enterprise', description: 'Compare Induce and Synthesia Enterprise for agency and enterprise video production.', path: '/vs/synthesia' },
    heading: 'Induce vs Synthesia: AI Video for Agencies and Enterprise Teams',
    intro: 'Explore the difference between script-driven cinematic production and presenter-led video.',
    audience: 'enterprise',
  },
  heygen: {
    meta: { title: 'HeyGen Alternative | Induce vs HeyGen for Branded Video', description: 'Compare Induce and HeyGen for branded video production.', path: '/vs/heygen' },
    heading: 'Induce vs HeyGen: Script-Driven AI Video vs Avatar Video',
    intro: 'See which approach fits your brief, whether it calls for a cinematic story or an on-screen presenter.',
    audience: 'agencies',
  },
  'ltx-studio': {
    meta: { title: 'LTX Studio Alternative | Induce vs LTX Studio', description: 'Compare Induce and LTX Studio approaches to AI filmmaking.', path: '/vs/ltx-studio' },
    heading: 'Induce vs LTX Studio: Two Approaches to AI Filmmaking',
    intro: 'Compare the workflows for developing a script, planning shots, and making a film.',
    audience: 'filmmakers',
  },
};
